
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { mmI18nConstants } from './i18n-constants';
const prefix = mmI18nConstants.translationGroup;
@Injectable({ providedIn: 'root' })
export class I18nTranslations {
    constructor(private translateService: TranslateService) {

    }

    lang(code) {
        return this.translateService.get(`${prefix}.${code}`)
    }

    language = this.translateService.get(`${prefix}.Language`)
    text = this.translateService.get(`${prefix}.Text`)



}